'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createScroll;

var _Friction = require('./Friction');

var _Friction2 = _interopRequireDefault(_Friction);

var _createSpring = require('./createSpring');

var _createSpring2 = _interopRequireDefault(_createSpring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Stop(x, v, secPerStep, elapsed) {
  return [x, 0, true];
}

var ScrollMotion = function () {
  function ScrollMotion(config) {
    _classCallCheck(this, ScrollMotion);

    this._accelerationFunction = _Friction2.default;

    this._config = config;
  }

  _createClass(ScrollMotion, [{
    key: 'getAccelerationFunction',
    value: function getAccelerationFunction(x) {
      if (this._accelerationFunction === _Friction2.default) {
        var _config = this._config,
            min = _config.min,
            max = _config.max,
            bounce = _config.bounce;

        if (typeof min === 'number' && x <= min) {
          this._accelerationFunction = bounce ? (0, _createSpring2.default)(min, 100, 20) : Stop;
        }
        if (typeof max === 'number' && x >= max) {
          this._accelerationFunction = bounce ? (0, _createSpring2.default)(max, 80, 20) : Stop;
        }
      }
      return this._accelerationFunction;
    }
  }]);

  return ScrollMotion;
}();

function createScroll(config) {
  var s = new ScrollMotion(config);
  return function (x, v, secPerStep, elapsed) {
    return s.getAccelerationFunction(x)(x, v, secPerStep, elapsed);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/steppers/createScroll.js
// module id = 171
// module chunks = 0